import { type ComponentProps } from "react";

const HomeIcon = (props: ComponentProps<"svg">) => {
  return (
    <svg
      width="25"
      height="27"
      viewBox="0 0 25 27"
      fill="currentColor"
      {...props}
    >
      <path d="M3 26.25C2.175 26.25 1.469 25.9565 0.882 25.3695C0.294 24.7815 0 24.075 0 23.25V9.75C0 9.275 0.1065 8.825 0.3195 8.4C0.5315 7.975 0.825 7.625 1.2 7.35L10.2 0.6C10.475 0.4 10.7625 0.25 11.0625 0.15C11.3625 0.0499999 11.675 0 12 0C12.325 0 12.6375 0.0499999 12.9375 0.15C13.2375 0.25 13.525 0.4 13.8 0.6L22.8 7.35C23.175 7.625 23.469 7.975 23.682 8.4C23.894 8.825 24 9.275 24 9.75V23.25C24 24.075 23.7065 24.7815 23.1195 25.3695C22.5315 25.9565 21.825 26.25 21 26.25H15V15.75H9V26.25H3Z" />
    </svg>
  );
};

HomeIcon.displayName = "HomeIcon";

export default HomeIcon;
